// Text helpers for food-truck stops: how a spot's name and address read on
// the truck pages.

// Small words stay lower case inside a title ("Corner of Main and Elm").
const MINOR = new Set(["a", "an", "and", "at", "by", "for", "in", "of", "on", "or", "the", "to"]);

/**
 * "harvard square" → "Harvard Square". Only first letters are raised, so a
 * name the owner typed with its own capitals ("IHOP lot") keeps them.
 */
export function titleCaseSpot(name) {
  if (!name) return name;
  const words = String(name).trim().split(/\s+/);
  return words
    .map((w, i) => {
      if (i > 0 && i < words.length - 1 && MINOR.has(w.toLowerCase())) return w.toLowerCase();
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(" ");
}

const STATES = {
  alabama: "AL", alaska: "AK", arizona: "AZ", arkansas: "AR", california: "CA", colorado: "CO",
  connecticut: "CT", delaware: "DE", "district of columbia": "DC", florida: "FL", georgia: "GA",
  hawaii: "HI", idaho: "ID", illinois: "IL", indiana: "IN", iowa: "IA", kansas: "KS", kentucky: "KY",
  louisiana: "LA", maine: "ME", maryland: "MD", massachusetts: "MA", michigan: "MI", minnesota: "MN",
  mississippi: "MS", missouri: "MO", montana: "MT", nebraska: "NE", nevada: "NV", "new hampshire": "NH",
  "new jersey": "NJ", "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND",
  ohio: "OH", oklahoma: "OK", oregon: "OR", pennsylvania: "PA", "rhode island": "RI",
  "south carolina": "SC", "south dakota": "SD", tennessee: "TN", texas: "TX", utah: "UT", vermont: "VT",
  virginia: "VA", washington: "WA", "west virginia": "WV", wisconsin: "WI", wyoming: "WY",
};
const COUNTRY = /^(united states( of america)?|usa|us)$/i;

/**
 * "495 Great Road, Acton, Massachusetts 01720, United States"
 *   → "495 Great Road, Acton, MA 01720"
 * The country goes and a spelled-out state becomes its two letters, so the
 * address fits on a card without being cut off. Anything it doesn't
 * recognise is left as it was.
 */
export function shortAddress(address) {
  if (!address) return address;
  const parts = String(address).split(",").map((p) => p.trim()).filter(Boolean);
  if (parts.length > 1 && COUNTRY.test(parts[parts.length - 1])) parts.pop();
  return parts
    .map((part) => {
      const m = part.match(/^([A-Za-z .]+?)\s+(\d{5}(?:-\d{4})?)$/);
      if (m && STATES[m[1].toLowerCase()]) return `${STATES[m[1].toLowerCase()]} ${m[2]}`;
      if (STATES[part.toLowerCase()]) return STATES[part.toLowerCase()];
      return part;
    })
    .join(", ");
}
